import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ClientLayout from '../../components/client/ClientLayout';
import ClientDashboard from './ClientDashboard';
import ClientProducts from './ClientProducts';
import ClientOrders from './ClientOrders';
import ClientProfile from './ClientProfile';
import ClientRemitos from './ClientRemitos';
import ClientStock from './ClientStock';
import { useAuth } from '../../contexts/AuthContext';

const Client: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-600">Verificando sesión…</div>;
  }

  // Verificar que el usuario esté autenticado y sea cliente
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'cliente') {
    return <Navigate to="/" replace />;
  }

  const isCompany = user.clientType === 'empresa';

  return (
    <ClientLayout>
      <Routes>
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<ClientDashboard />} />
        <Route path="productos" element={isCompany ? <Navigate to="/cliente/dashboard" replace /> : <ClientProducts />} />
        <Route path="cotizaciones" element={isCompany ? <Navigate to="/cliente/dashboard" replace /> : <Navigate to="/contacto?subject=cotizacion" replace />} />
        <Route path="pedidos" element={<ClientOrders />} />
        <Route path="remitos" element={<ClientRemitos />} />
        <Route path="stock" element={isCompany ? <ClientStock /> : <Navigate to="/cliente/dashboard" replace />} />
        <Route path="perfil" element={<ClientProfile />} />
      </Routes>
    </ClientLayout>
  );
};

export default Client;
